import { EMPTY_ACTION } from '../../app/store'
import {
  getConfirmPatientHasNoAllergyEndPoint,
  getUnConfirmPatientHasNoAllergyEndPoint,
  methods,
} from '../../utils/apiHelper'
import { getTabId } from '../../utils/common'
import { apiCall } from '../../utils/restclient'
import {
  ADD_ALERT,
  ADD_ALERT_ERROR,
  ADD_ALERT_SUCCESS,
  ADD_MEDIA_FILE,
  ADD_MEDIA_FILE_ERROR,
  ADD_MEDIA_FILE_SUCCESS,
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  ADD_PATIENT_ALLERGY_SUCCESS,
  CHECK_PHONE,
  CHECK_PHONE_ERROR,
  CHECK_PHONE_SUCCESS,
  COMPLETE_VISIT,
  COMPLETE_VISIT_ERROR,
  COMPLETE_VISIT_SUCCESS,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_ALERT_SUCCESS,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  DELETE_PATIENT_ALLERGY_SUCCESS,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  EDIT_ALERT_SUCCESS,
  GET_ALERTS,
  GET_ALERTS_ERROR,
  GET_ALERTS_SUCCESS,
  GET_INTAKE_FORM,
  GET_INTAKE_FORM_ERROR,
  GET_INTAKE_FORM_SUCCESS,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_MEDIA_FILES_SUCCESS,
  GET_PAST_VISIT_INFO,
  GET_PAST_VISIT_INFO_ERROR,
  GET_PAST_VISIT_INFO_SILENCE,
  GET_PAST_VISIT_INFO_SUCCESS,
  GET_PAST_VISIT_TREAT_LINK,
  GET_PAST_VISIT_TREAT_LINK_ERROR,
  GET_PAST_VISIT_TREAT_LINK_SUCCESS,
  GET_PATIENT_INTAKE_FORMS,
  GET_PATIENT_INTAKE_FORMS_ERROR,
  GET_PATIENT_INTAKE_FORMS_SUCCESS,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_PAST_VISITS_SUCCESS,
  GET_PATIENT_TREAT_LINK,
  GET_PATIENT_TREAT_LINK_ERROR,
  GET_PATIENT_TREAT_LINK_SUCCESS,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PATIENT_UPCOMING_VISITS_SUCCESS,
  GET_PATIENTS_CHART,
  GET_PATIENTS_CHART_ERROR,
  GET_PATIENTS_CHART_SUCCESS,
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_ERROR,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PRESCRIPTIONS,
  GET_PRESCRIPTIONS_ERROR,
  GET_PRESCRIPTIONS_SUCCESS,
  MARK_ALL_USER_ALERTS_AS_READ,
  MARK_ALL_USER_ALERTS_AS_READ_ERROR,
  MARK_ALL_USER_ALERTS_AS_READ_SUCCESS,
  SAVE_ACCOUNT_INFO,
  SAVE_ACCOUNT_INFO_ERROR,
  SAVE_ACCOUNT_INFO_SUCCESS,
  SAVE_GENERAL_INFO,
  SAVE_GENERAL_INFO_ERROR,
  SAVE_GENERAL_INFO_SUCCESS,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS,
  SAVE_VISIT_NOTES_ADDENDUM,
  SAVE_VISIT_NOTES_ADDENDUM_ERROR,
  SAVE_VISIT_NOTES_ADDENDUM_SUCCESS,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  SEARCH_FOR_ICD_CODES_SUCCESS,
  SEARCH_PHARMACIES,
  SEARCH_PHARMACIES_ERROR,
  SEARCH_PHARMACIES_SUCCESS,
  SET_MEDIA_FILE_TAGS,
  SET_MEDIA_FILE_TAGS_ERROR,
  SET_MEDIA_FILE_TAGS_SUCCESS,
  SET_PATIENT_HAS_ALLERGIES,
  SET_PATIENT_HAS_ALLERGIES_ERROR,
  SET_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_PATIENT_HAS_NO_ALLERGIES,
  SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  UNRESOLVE_VISIT,
  UNRESOLVE_VISIT_ERROR,
  UNRESOLVE_VISIT_SUCCESS,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
  UPDATE_ICD_CODES_SUCCESS,
} from './ChartsConstants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function addAlert({ Message, patientId, IsPrivate, tabId }) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/alerts`
    const action = {
      type: ADD_ALERT,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'POST', null, JSON.stringify({ Message, IsPrivate }), {
        success: ADD_ALERT_SUCCESS,
        error: ADD_ALERT_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function saveGeneralInfo(patientId, info, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/generalinfo`
    const action = {
      type: SAVE_GENERAL_INFO,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'PUT', null, JSON.stringify(info), {
        success: SAVE_GENERAL_INFO_SUCCESS,
        error: SAVE_GENERAL_INFO_ERROR,
        extraData: { generalInfo: info, patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function saveAccountInfo({ patientId, info, pharmacyInfo, tabId }) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/accountinfo`
    const action = {
      type: SAVE_ACCOUNT_INFO,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'PUT', null, JSON.stringify(info), {
        success: SAVE_ACCOUNT_INFO_SUCCESS,
        error: SAVE_ACCOUNT_INFO_ERROR,
        extraData: { accountInfo: info, pharmacyInfo, patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function markAllUserAlertsAsRead(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/alerts/markasread`
    const action = {
      type: MARK_ALL_USER_ALERTS_AS_READ,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'PUT', null, null, {
        success: MARK_ALL_USER_ALERTS_AS_READ_SUCCESS,
        error: MARK_ALL_USER_ALERTS_AS_READ_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function deleteAlert(patientId, alertId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/alerts/${alertId}`
    const action = {
      type: DELETE_ALERT,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'DELETE', null, null, {
        success: DELETE_ALERT_SUCCESS,
        error: DELETE_ALERT_ERROR,
        extraData: { patientId, tabId, alertId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function editAlert({ Message, patientId, alertId, IsPrivate, tabId }) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/alerts/${alertId}`
    const action = {
      type: EDIT_ALERT,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'PUT', null, JSON.stringify({ Message, IsPrivate }), {
        success: EDIT_ALERT_SUCCESS,
        error: EDIT_ALERT_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getAlerts(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/alerts`
    const action = {
      type: GET_ALERTS,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_ALERTS_SUCCESS,
        error: GET_ALERTS_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getPastVisitTreatLink(visitId) {
  const endpoint = `api/v1/visits/${visitId}/treaturl`
  const action = {
    type: GET_PAST_VISIT_TREAT_LINK,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PAST_VISIT_TREAT_LINK_SUCCESS,
      error: GET_PAST_VISIT_TREAT_LINK_ERROR,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function searchForICDCodes(searchValue, visitId, searchId) {
  const endpoint = `api/v1/icdcodes?SearchValue=${encodeURIComponent(searchValue)}`
  const action = {
    type: SEARCH_FOR_ICD_CODES,
    extraData: { visitId },
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: SEARCH_FOR_ICD_CODES_SUCCESS,
        error: SEARCH_FOR_ICD_CODES_ERROR,
        extraData: { visitId, searchId },
      },
      null,
      null,
      null,
      null,
      true,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const updateICDCodes = ({ visitId, codes, tabId }) => {
  const endpoint = `api/v1/visits/${visitId}/icdcodes`
  const action = {
    type: UPDATE_ICD_CODES,
    extraData: { visitId },
  }
  const requestBody = {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    IcdCodeIds: codes.map((code) => code.IcdCodeId),
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(requestBody), {
      success: UPDATE_ICD_CODES_SUCCESS,
      error: UPDATE_ICD_CODES_ERROR,
      extraData: { codes, visitId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getPastVisits(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/visits/past`
    const action = {
      type: GET_PATIENT_PAST_VISITS,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_PATIENT_PAST_VISITS_SUCCESS,
        error: GET_PATIENT_PAST_VISITS_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getUpcomingVisits(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/visits/upcoming`
    const action = {
      type: GET_PATIENT_UPCOMING_VISITS,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_PATIENT_UPCOMING_VISITS_SUCCESS,
        error: GET_PATIENT_UPCOMING_VISITS_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function completeVisit(visitId, tabId) {
  const endpoint = `api/v1/visits/${visitId}/complete`
  const action = {
    type: COMPLETE_VISIT,
    extraData: { visitId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, null, {
      success: COMPLETE_VISIT_SUCCESS,
      error: COMPLETE_VISIT_ERROR,
      extraData: { visitId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function unresolveVisit({ visitId, message, tabId }) {
  const endpoint = `api/v1/visits/${visitId}/unresolve`
  const action = {
    type: UNRESOLVE_VISIT,
    extraData: { visitId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify({ Message: message }), {
      success: UNRESOLVE_VISIT_SUCCESS,
      error: UNRESOLVE_VISIT_ERROR,
      extraData: { visitId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getPastVisitInfo = ({ visitId, isSilence }) => {
  const endpoint = `api/v1/visits/${visitId}`
  const action = {
    type: isSilence ? GET_PAST_VISIT_INFO_SILENCE : GET_PAST_VISIT_INFO,
    extraData: { visitId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PAST_VISIT_INFO_SUCCESS,
      error: GET_PAST_VISIT_INFO_ERROR,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function geIntakeForms(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/intakeforms`
    const action = {
      type: GET_PATIENT_INTAKE_FORMS,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_PATIENT_INTAKE_FORMS_SUCCESS,
        error: GET_PATIENT_INTAKE_FORMS_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getChartPatientsList = (offset, count = '', searchStringCondition = '', isUpdatePatientsList) => {
  const endpoint = `api/v1/patients?Offset=${offset}&Count=${count}&SearchValue=${encodeURIComponent(
    searchStringCondition,
  ).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`)}`
  const action = {
    type: GET_PATIENTS_LIST,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENTS_LIST_SUCCESS,
      error: GET_PATIENTS_LIST_ERROR,
      extraData: { isUpdatePatientsList },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function getMediaFiles({ patientId, mediaFiles, tabId }) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/mediafiles`
    const action = {
      type: GET_MEDIA_FILES,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_MEDIA_FILES_SUCCESS,
        error: GET_MEDIA_FILES_ERROR,
        extraData: { patientId, mediaFiles, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function setMediaFileTags({ patientId, fileId, updateRequestBody }, mediaFiles, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/mediafiles/${fileId}`
    const action = {
      type: SET_MEDIA_FILE_TAGS,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'PUT', null, JSON.stringify(updateRequestBody), {
        success: SET_MEDIA_FILE_TAGS_SUCCESS,
        error: SET_MEDIA_FILE_TAGS_ERROR,
        extraData: { patientId, mediaFiles, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const addMediaFile = ({ patientId, data }, mediaFiles, shouldRefresh = true, tabId = '') => {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/mediafiles`
    const action = {
      type: ADD_MEDIA_FILE,
      extraData: { patientId, mediaFiles, shouldRefresh, tabId },
    }
    try {
      apiCall(
        endpoint,
        'POST',
        null,
        data,
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        {
          success: ADD_MEDIA_FILE_SUCCESS,
          error: ADD_MEDIA_FILE_ERROR,
          extraData: { patientId, mediaFiles, shouldRefresh, tabId },
        },
        null,
        {},
      )
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientTreatLinkEndpoint = (patientId) => `api/v1/patients/${patientId}/treaturl`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getPatientTreatLink(patientId, tabId) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const action = {
      type: GET_PATIENT_TREAT_LINK,
      extraData: { tabId },
    }
    const endpoint = getPatientTreatLinkEndpoint(patientId)
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_PATIENT_TREAT_LINK_SUCCESS,
        error: GET_PATIENT_TREAT_LINK_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientChart = (id, tabId) => {
  const customCurrentTabId = getTabId()

  if (customCurrentTabId === tabId || !tabId) {
    const endpoint = `api/v1/patients/${id}`
    const action = {
      type: GET_PATIENTS_CHART,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_PATIENTS_CHART_SUCCESS,
        error: GET_PATIENTS_CHART_ERROR,
        extraData: { patientId: id, tabId, customCurrentTabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const addPatientAllergy = (patientId, allergy, tabId) => {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/allergies`
    const action = {
      type: ADD_PATIENT_ALLERGY,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'POST', null, JSON.stringify(allergy), {
        success: ADD_PATIENT_ALLERGY_SUCCESS,
        error: ADD_PATIENT_ALLERGY_ERROR,
        extraData: { patientId, tabId, allergy },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientPrescriptions = (patientId, tabId, showLoader = true) => {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/prescriptions`
    const action = {
      type: showLoader ? GET_PRESCRIPTIONS : 'NO_ACTION',
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'GET', null, null, {
        success: GET_PRESCRIPTIONS_SUCCESS,
        error: GET_PRESCRIPTIONS_ERROR,
        extraData: { patientId, tabId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const deletePatientAllergy = (patientId, allergyId, tabId) => {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = `api/v1/patients/${patientId}/allergies/${allergyId}`
    const action = {
      type: DELETE_PATIENT_ALLERGY,
      extraData: { tabId },
    }
    try {
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      apiCall(endpoint, 'DELETE', null, null, {
        success: DELETE_PATIENT_ALLERGY_SUCCESS,
        error: DELETE_PATIENT_ALLERGY_ERROR,
        extraData: { patientId, tabId, allergyId },
      })
      return action
    } catch (e) {
      console.log(e)
    }
  } else {
    return {
      type: EMPTY_ACTION,
    }
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function checkPhone({ number, phoneCoutryCode, country, tabId }) {
  const currentTabId = getTabId()

  if (currentTabId === tabId) {
    const endpoint = 'api/v1/utilities/validatephonenumber'
    const action = {
      type: CHECK_PHONE,
      payload: number,
      extraData: { tabId },
    }
    apiCall(
      endpoint,
      'POST',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify({
        Number: `+${phoneCoutryCode}${number}`,
        Prefix: `+${phoneCoutryCode}`,
        CountryCode: country,
      }),
      {
        success: CHECK_PHONE_SUCCESS,
        error: CHECK_PHONE_ERROR,
        extraData: { number, tabId },
      },
    )
    return action
  }
  return {
    type: EMPTY_ACTION,
  }
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function checkPhoneAsync({ number, phoneCoutryCode, country, tabId }) {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const currentTabId = getTabId()

      if (currentTabId === tabId) {
        const endpoint = 'api/v1/utilities/validatephonenumber'

        // Dispatch the initial action
        dispatch({
          type: CHECK_PHONE,
          payload: number,
          extraData: { tabId },
        })

        // Make the API call
        apiCall(
          endpoint,
          'POST',
          null,
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          JSON.stringify({
            Number: `+${phoneCoutryCode}${number}`,
            Prefix: `+${phoneCoutryCode}`,
            CountryCode: country,
          }),
          {
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            success: (response) => {
              // Dispatch success action
              dispatch({
                type: CHECK_PHONE_SUCCESS,
                payload: response,
                extraData: { number, tabId },
              })
              // Resolve the promise
              resolve(response)
            },
            // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
            error: (error) => {
              // Dispatch error action
              dispatch({
                type: CHECK_PHONE_ERROR,
                error,
                extraData: { number, tabId },
              })
              // Reject the promise
              reject(error)
            },
          },
        )
      } else {
        // Dispatch an empty action if tab IDs don't match
        dispatch({
          type: EMPTY_ACTION,
        })
        // @ts-expect-error TS2794 -- MIGRATION: not approved, fix when encountered
        resolve() // Resolve the promise even if no action is taken
      }
    })
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getIntakeForm = ({ patientId, intakeFormId }) => {
  const endpoint = `api/v1/patients/${patientId}/intakeforms/${intakeFormId}`
  const action = {
    type: GET_INTAKE_FORM,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_INTAKE_FORM_SUCCESS,
      error: GET_INTAKE_FORM_ERROR,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const searchPharmacies = (searchValue, patientId) => {
  const endpoint = `api/v1/pharmacies?PatientId=${patientId}&Count=10${
    searchValue ? `&SearchValue=${searchValue}` : ''
  }`
  const action = {
    type: SEARCH_PHARMACIES,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: SEARCH_PHARMACIES_SUCCESS,
      error: SEARCH_PHARMACIES_ERROR,
    })

    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const saveVisitNotesAddendum = ({ visitId, Note, isWithoutSaving, tabId }) => {
  const endpoint = `api/v1/visits/${visitId}/notes`
  const action = {
    type: SAVE_VISIT_NOTES_ADDENDUM,
    extraData: { visitId },
  }
  const requestBody = {
    Message: Note,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(requestBody), {
      success: SAVE_VISIT_NOTES_ADDENDUM_SUCCESS,
      error: SAVE_VISIT_NOTES_ADDENDUM_ERROR,
      extraData: { isWithoutSaving, visitId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const savePatientInstructionsAddendum = ({ visitId, PatientInstructions, isWithoutSaving, tabId }) => {
  const endpoint = `api/v1/visits/${visitId}/patientinstructions`
  const action = {
    type: SAVE_PATIENT_INSTRUCTIONS_ADDENDUM,
    extraData: { visitId },
  }
  const requestBody = {
    Message: PatientInstructions,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'POST', null, JSON.stringify(requestBody), {
      success: SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS,
      error: SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR,
      extraData: { isWithoutSaving, visitId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientHasNoAllergies = (patientId, tabId) => {
  const endpoint = getConfirmPatientHasNoAllergyEndPoint(patientId)
  const action = {
    type: SET_PATIENT_HAS_NO_ALLERGIES,
    extraData: { patientId, tabId },
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, null, {
      success: SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
      error: SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
      extraData: { patientId, tabId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientHasAllergies = (patientId, tabId) => {
  const endpoint = getUnConfirmPatientHasNoAllergyEndPoint(patientId)
  const action = {
    type: SET_PATIENT_HAS_ALLERGIES,
    extraData: { patientId, tabId },
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, null, {
      success: SET_PATIENT_HAS_ALLERGIES_SUCCESS,
      error: SET_PATIENT_HAS_ALLERGIES_ERROR,
      extraData: { patientId, tabId },
    })

    return action
  } catch (e) {
    console.log(e)
  }
}
